import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';
import createContainer from 'constate';
import { getItemsById, pipe } from './helper.js';
import { moveItem, resetMovedItems, navigateTo, resetCheckedItems, toggleItemSelection } from './Shuttle.actions.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';
import './utils.js';

function useShuttleState() {
  var _useState = useState({
    checkedItems: [],
    movedItems: {},
    hierarchy: [{
      name: 'Category',
      id: null
    }],
    hierarchyDest: [{
      name: 'Added users',
      id: null
    }]
  }),
      _useState2 = _slicedToArray(_useState, 2),
      shuttleState = _useState2[0],
      setShuttleState = _useState2[1];

  var setState = function setState(state) {
    return setShuttleState(state(shuttleState));
  };

  function setMovedItems() {
    var itemsIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var itemsToMove = getItemsById(itemsIds, items);
    var pipeActions = itemsToMove.map(function (item) {
      return moveItem(item);
    });
    setState(pipe([resetMovedItems()].concat(_toConsumableArray(pipeActions))));
  }

  function navigate(item, dest) {
    setState(pipe([navigateTo(item, dest), resetCheckedItems()]));
  }

  function resetCheckedItems$1() {
    setState(resetCheckedItems());
  }

  function resetMovedItems$1() {
    setState(pipe([navigateTo({
      id: null
    }, true), resetMovedItems()]));
  }

  function moveItem$1(item, dest) {
    setState(pipe([moveItem(item), resetCheckedItems()]));
  }

  function toggleItemSelection$1(item) {
    setState(toggleItemSelection(item.id));
  }

  function moveCheckedItems(items) {
    var pipeActions = items.map(function (item) {
      return moveItem$1(item);
    });
    setState(pipe([].concat(_toConsumableArray(pipeActions), [resetCheckedItems$1()])));
  }

  return {
    state: shuttleState,
    toggleItemSelection: toggleItemSelection$1,
    moveCheckedItems: moveCheckedItems,
    moveItem: moveItem$1,
    resetMovedItems: resetMovedItems$1,
    resetCheckedItems: resetCheckedItems$1,
    navigate: navigate,
    setMovedItems: setMovedItems
  };
}

var useShuttleState$1 = createContainer(useShuttleState, function (value) {
  return [value.state];
});

export default useShuttleState$1;
//# sourceMappingURL=ShuttleState.js.map
